module.exports = __webpack_public_path__ + "media/images/dollar-cross-52e29148215de5d2c727761f63f3ae4f.svg";